// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mQ0j","right":"styles_right__2bLgj"};